let dictionary = {
    'admin-detail-409-error': 'Já existe um usuário com este e-mail',
    'admin-detail-delete-confirm-text': 'Remover usuário?',
    'admin-detail-delete-success': 'Usuário removido',
    'admin-detail-form-admin-access-group': 'Grupo de acesso',
    'admin-detail-form-admin-email': 'E-mail',
    'admin-detail-form-admin-name': 'Nome',
    'admin-detail-form-admin-new-password':'Nova senha',
    'admin-detail-form-admin-password': 'Senha',
    'admin-detail-form-admin-sector': 'Setor',
    'admin-detail-form-current_password': 'Senha atual',
    'admin-detail-form-desactivate-switch': 'Ativar/desativar usuário do sistema',
    'admin-detail-form-error-password-min-length': 'Mínimo de 6 caractéres',
    'admin-detail-form-image-hint' : 'Enviar foto',
    'admin-detail-save-success': 'Usuário salvo',
    'admin-detail-title': 'Detalhes do usuário',
    'admin-detail-title-caption': 'Preencha os dados do usuário conforme os campos abaixo',
    'admin-list-create-admin-button': 'Criar usuário',
    'admin-list-empty-state-line-1': 'Nenhum usuário',
    'admin-list-empty-state-line-2': 'Crie seu primeiro usuário',
    'admin-list-table-access-group-null': 'Sem grupo',
    'admin-list-table-header-access-group': 'Grupo de acesso',
    'admin-list-table-header-created-at': 'Criado em',
    'admin-list-table-header-email': 'E-mail',
    'admin-list-table-header-name': 'Nome',
    'attendance-list-active-success': 'Pré-atendimento atualizado',
    'attendance-list-active-error': 'Não foi possível completar esta ação',
    'attendance-detail-city': 'Cidade',
    'attendance-detail-finished': 'Status do pré-agendamento',
    'attendance-detail-medical-request-title': 'Pedido Médico',
    'attendance-detail-health-insurance-front_image': 'Frente da carteirinha',
    'attendance-detail-health-insurance-rear_image': 'Verso da carteirinha',
    'attendance-detail-place': 'Local do atendimento',
    'attendance-detail-service': 'Nome do serviço',
    'attendance-detail-state': 'Estado',
    'attendance-detail-title': 'Detalhe do pré-atendimento',
    'attendance-detail-title-caption': 'Leia abaixo maiores informações sobre o pré-agendamento',
    'attendance-detail-type': 'Tipo',
    'attendance-detail-reference-user-birthdate': 'Data de nascimento',
    'attendance-detail-reference-user-document': 'CPF',
    'attendance-detail-reference-user-email': 'E-mail',
    'attendance-detail-reference-user-name': 'Nome',
    'attendance-detail-reference-user-title': 'Usuário solicitante',
    'attendance-detail-reference-user-phone': 'Telefone',
    'attendance-detail-reference-user-title-caption': 'Dados do usuário solicitante',
    'attendance-detail-unit-address': 'Endereço',
    'attendance-detail-unit-name': 'Unidade',
    'attendance-info-HOME': 'Domiciliar',
    'attendance-info-PRE_SCHEDULING': 'Pré-agendamento',
    'attendance-info-BUDGET': 'Orçamento',
    'attendance-info-EXAM': 'Exame laboratorial',
    'attendance-info-CHECKUP': 'Check-up',
    'attendance-info-IMAGE': 'Exame de imagem',
    'attendance-info-UNIT': 'Unidade Sabin',
    'attendance-info-VACCINE': 'Vacina',
    'attendance-list-table-header-city': 'Cidade',
    'attendance-list-table-header-finished': 'Atendido',
    'attendance-list-table-header-name': 'Nome',
    'attendance-list-table-header-place': 'Local',
    'attendance-list-table-header-service': 'Serviço',
    'attendance-list-table-header-state': 'Estado',
    'attendance-list-table-header-type': 'Tipo',
    'attendance-list-table-header-unit': 'Unidade',
    'button-download-report': 'Baixar relatório analítico',
    'button-download-report-small': 'Visualizar relatório sintético',
    'button-download-report-spin': 'Gerando relatório',
    'auth-service-forbid-access-dialog-text': 'Entre em contato com o administrador do sistema.',
    'auth-service-forbid-access-dialog-title': '403 - Acesso proibido',
    'campaign-create-page-title': 'Detalhe da campanha',
    'campaign-detail-409-error': 'Já existe uma campanha neste período',
    'campaign-detail-delete-confirm-text': 'Remover campanha?',
    'campaign-detail-delete-success': 'Campanha removida',
    'campaign-detail-form-dates-sub-header': 'Informe as datas de início de fim da campanha *',
    'campaign-detail-form-end_date': 'Finaliza em',
    'campaign-detail-form-image-hint': 'A imagem será salva no tamanho 570 x 890 px.',
    'campaign-detail-form-news-item': 'Notícia vinculada',
    'campaign-detail-form-news-item-placeholder': 'Pesquise por uma notícia',
    'campaign-detail-form-news-item-sub-header': 'Vincule uma notícia a esta campanha',
    'campaign-detail-form-news-name': 'Nome da campanha',
    'campaign-detail-form-start_date': 'Inicia em',
    'campaign-detail-save-success': 'Campanha salva',
    'campaign-detail-title-caption': 'Preencha os dados da campanha conforme os campos abaixo',
    'campaign-image-title-caption': 'Escolha uma imagem para a campanha',
    'campaign-list-create-campaign-button': 'Nova campanha',
    'campaign-list-empty-state-line-1': 'Nenhuma campanha',
    'campaign-list-empty-state-line-2': 'Crie sua primeira campanha',
    'campaign-list-table-header-end_date': 'Finaliza em',
    'campaign-list-table-header-name': 'Nome da campanha',
    'campaign-list-table-header-start_date': 'Inicia em',
    'card-detail-409-error': 'Já existe uma vacina com esse nome',
    'card-detail-form-doses-label': 'Quantidade de doses',
    'card-detail-form-error-doses-max': 'A quantidade de doses deve ser no máximo 3',
    'card-detail-form-error-doses-min': 'A quantidade de doses deve ser no mínimo 1',
    'card-detail-form-error-interval_in_days-min': 'O intervalo deve ser no mínimo 1 dia',
    'card-detail-form-interval-value-label': 'Intervalo entre as doses',
    'card-detail-form-time-unit': 'Unidade de tempo',
    'card-detail-save-success': 'Vacina salva',
    'card-detail-title': 'Detalhes da vacinação',
    'card-detail-title-caption': 'Preencha os dados da vacinação conforme os campos abaixo',
    'card-list-create-card-button': 'Criar vacina',
    'card-list-empty-state-line-1': 'Nenuma vacina cadastrada',
    'card-list-empty-state-line-2': 'Crie sua primeira vacina',
    'insurance-state-detail-title': 'Detalhes do Estado',
    'insurance-city-detail-title': 'Detalhes da Cidade',
    'insurance-detail-title': 'Detalhes do Convênio',
    'insurance-detail-form-expire-label': 'Validade do pedido (dias)',
    'insurance-detail-save-success': 'Convênio salvo',
    'insurance-state-detail-save-success': 'Estado salvo',
    'insurance-city-detail-save-success': 'Cidade salva',
    'client-detail-form-client-address_complement': 'Complemento',
    'client-detail-form-client-address_neighborhood': 'Bairro',
    'client-detail-form-client-address_number': 'Número',
    'client-detail-form-client-address_postal_code': 'CEP',
    'client-detail-form-client-address_street': 'Endereço',
    'client-detail-form-client-birthdate': 'Data de nascimento',
    'client-detail-form-client-city_id': 'Cidade',
    'client-detail-form-client-cpf': 'CPF',
    'client-detail-form-client-email': 'E-mail',
    'client-detail-form-client-gender': 'Gênero',
    'client-detail-form-client-name': 'Nome completo',
    'client-detail-form-client-phone_number': 'Telefone',
    'client-detail-form-client-state': 'Estado',
    'client-detail-form-client-period': 'Período',
    'client-detail-remove-association-confirm-text': 'Remover vínculo',
    'client-detail-save-success': 'Cliente salvo',
    'client-detail-section-dependents-empty-state-line-1': 'Este cliente não tem dependentes',
    'client-detail-section-dependents-remove-button-text': 'Remover vínculo',
    'client-detail-section-health_insurances-empty-state-line-1': 'Nenhum convênio cadastrado',
    'client-detail-section-health_insurances-name': 'Convênio',
    'client-detail-section-sponsors-empty-state-line-1': 'Este cliente não é dependente de nenhum usuário',
    'client-detail-section-sponsors-remove-button-text': 'Remover vínculo',
    'client-detail-section-title-dependents': 'Dependentes vinculados',
    'client-detail-section-title-dependents-caption': 'Remova vínculos deste cliente',
    'client-detail-section-title-health_insurances': 'Detalhes do convênio',
    'client-detail-section-title-sponsors': 'Responsáveis',
    'client-detail-section-title-sponsors-caption': 'Remova vínculos deste cliente',
    'client-detail-title': 'Detalhes do cliente',
    'client-detail-title-caption': 'Edite as informações abaixo conforme necessário',
    'client-report-title': 'Relatório sintético',
    'client-report-title-caption': 'Dashboard gráfico de clientes',
    'client-report-chart-clients': 'Total de clientes',
    'client-report-chart-clients-gender': 'Total de clientes por gênero',
    'client-report-chart-clients-dependents': 'Total de clientes por dependentes',
    'client-report-chart-clients-states': 'Total de clientes por estados',
    'client-report-title-subtitle': 'Relatório analítico',
    'client-report-title-subtitle-caption': 'Selecione as opções de filtragem para gerar o relatório',
    'client-report-filter': 'Gerar relatório analítico',
    'client-report-filtering': 'Gerando relatório analítico',
    'client-report-graph-filter': 'Gerar gráfico analítico',
    'client-report-graph-filtering': 'Gerando gráfico analítico',
    'common-about-text': 'Sobre',
    'common-actions': 'Ações',
    'common-all-rights-reserved-text': 'Todos os direitos reservados.',
    'common-campaign': 'Campanha',
    'common-communicate': 'Comunicado',
    'common-cancel': 'Cancelar',
    'common-cancel-button-text': 'Cancelar',
    'common-category': 'Categoria',
    'common-subcategory': 'Subcategoria',
    'common-add-subcategory': 'Adicionar Subcategoria',
    'common-choose-a-file': 'Escolher um arquivo',
    'common-city': 'Cidade',
    'common-clear-button-text': 'Limpar',
    'common-clients': 'Clientes',
    'common-create': 'Criar',
    'common-create-button-text': 'Criar',
    'common-created-at-feminine': 'Criada em',
    'common-date': 'Data',
    'common-delete': 'Remover',
    'common-delete-button-text': 'Remover',
    'common-detail-delete-confirm-text': 'Remover este item?',
    'common-detail-delete-success': 'Item removido',
    'common-edit': 'Editar',
    'common-email': 'E-mail',
    'common-female': 'Feminino',
    'common-form-error-sb-after-date': 'A data final não pode ser antes da data inicial',
    'common-form-error-sb-before-date': 'A data inicial não pode ser depois da data final',
    'common-form-error-sb-today-or-before': 'Data de nascimento inválida',
    'common-form-error-sb-today-or-later': 'A data não pode ser antes de hoje',
    'common-form-incomplete': 'Formulário incompleto',
    'common-general': 'Geral',
    'common-go-back-button-text': 'Voltar',
    'common-help-text': 'Ajuda',
    'common-hours': 'horas',
    'common-image': 'Imagem',
    'common-load-error': 'Houve um erro os carregar os dados',
    'common-loading': 'Carregando',
    'common-male': 'Masculino',
    'common-medics': 'Médicos',
    'common-dependents': 'Dependentes',
    'common-message': 'Mensagem',
    'common-name': 'Nome',
    'common-gender': 'Sexo',
    'common-new-feminine': 'Nova',
    'common-new-feminine-city': 'Nova cidade',
    'common-new-masculine': 'Novo',
    'common-new-pop-up': 'Novo Pop-up',
    'common-new-video': 'Novo Banner',
    'common-all-feminine': 'Todas',
    'common-all-masculine': 'Todos',
    'common-none-feminine': 'Nenhuma',
    'common-none-masculine': 'Nenhum',
    'common-not-informed': 'Não informado',
    'common-ok': 'OK',
    'common-other-gender': 'Outro',
    'common-password': 'Senha',
    'common-phone-number': 'Telefone',
    'common-please-wait': 'Por favor aguarde',
    'common-published-at-feminine': 'Publicada em',
    'common-remove': 'Remover',
    'common-sabin': 'Sabin',
    'common-sabin-id': 'Código Shift',
    'common-save-button-loading-text': 'Salvando...',
    'common-save-button-text': 'Salvar',
    'common-save-error': 'Houve um erro ao salvar este item',
    'common-sent-at': 'Enviada em',
    'common-server-error': 'Não foi possível completar esta ação',
    'common-sicence-and-research': 'Pesquisa e ciência',
    'common-sign-out': 'Sair',
    'common-state': 'Estado',
    'common-time': 'Hora',
    'common-title': 'Título',
    'common-title-scheduled': 'Agendada para',
    'common-title-status': 'Status',
    'common-region': 'Região',
    'common-status': 'Status',
    'common-type-region': 'Tipo de região',
    'common-updated-at': 'Atualizado em',
    'common-pre-attendance': 'Pré-atendimento',
    'common-accept-pre-attendance': 'Aceita pré-atendimento',
    'common-no-accept-pre-attendance': 'Não aceita pré-atendimento',
    'common-updated-at-feminine': 'Atualizada em',
    'common-updated-active': 'Ativo',
    'common-user': 'Usuário',
    'common-yes': 'Sim',
    'common-unit': 'Unidade',
    'common-days': 'Días',
    'common-months': 'Meses',
    'common-years': 'Anos',
    'common-url': 'Inserir URL',
    'differential-detail-409-error': 'Já existe uma diferencial com esse nome',
    'differential-detail-save-success': 'Differencial salva',
    'differential-list-create-dialog-content': 'Dê um nome para o diferencial.',
    'faq-detail-title': 'Nova Pergunta',
    'faq-detail-title-response': 'Resposta',
    'faq-detail-title-platforms': 'Plataformas digitais',
    'faq-detail-input-title': 'Pergunta',
    'form-error-birthdate-invalid': 'Data inválida',
    'form-permission-checkbox-field': 'Permissões',
    'form-error-email-invalid': 'Este e-mail não é válido',
    'form-error-required-field': 'Campo obrigatório',
    'form-error-required-file': 'Arquivo obrigatório',
    'form-error-sb-time-field-now-or-later': 'A hora não pode ser antes de agora',
    'form-error-time-invalid': 'A hora deve ser no formato "hh:mm"',
    'group-detail-409-error': 'Já existe um grupo com este nome',
    'group-detail-delete-confirm-text': 'Remover grupo?',
    'group-detail-delete-success': 'Grupo removido',
    'group-detail-delete-with-users-confirm-text': 'Os usuários deste grupo perderão acesso à plataforma. Deseja remover?',
    'group-detail-form-group-name': 'Nome do grupo',
    'group-detail-no-access-confirm-text': 'Este grupo não tem acesso a nenhum módulo. Deseja salvar?',
    'group-detail-save-success': 'Grupo salvo',
    'group-detail-section-title-admin-modules': 'Módulos',
    'group-detail-section-title-admin-modules-caption': 'Selecione abaixo os módulos accesíveis por este grupo',
    'group-detail-section-title-admin-modules-caption-super': 'O acesso a módulos deste grupo não pode ser editado',
    'group-detail-title': 'Detalhes do grupo',
    'group-detail-title-caption': 'Preencha os dados do grupo conforme os campos abaixo',
    'group-list-create-group-button': 'Criar grupo de acesso',
    'group-list-empty-state-line-1': 'Nenhum grupo',
    'group-list-empty-state-line-2': 'Crie seu primeiro grupo',
    'group-list-table-all-modules-text': 'Todos',
    'group-list-table-header-modules': 'Módulos',
    'group-list-table-header-name': 'Grupo',
    'group-list-table-no-modules-text': 'Sem acesso',
    'list-empty-search-state-line-1': 'Nenhum resultado encontrado',
    'login-button-loading-text': 'Entrando...',
    'login-button-text': 'Entrar',
    'login-forgot-password-text': 'Esqueci minha senha',
    'login-remember-me-checkbox-text': 'Lembrar-me',
    'me-detail-403-error': 'Senha inválida',
    'me-detail-form-error-current_password-required': 'É necessário informar a senha atual para atualizar seu perfil',
    'me-detail-form-new-password': 'Nova senha',
    'me-detail-save-success': 'Suas informações foram salvas',
    'me-detail-title': 'Minha conta',
    'me-detail-title-caption': 'Atualize suas informações conforme necessário',
    'news-create-page-title': 'Nova notícia',
    'news-detail-delete-confirm-text': 'Remover notícia?',
    'news-detail-delete-success': 'Notícia removida',
    'news-detail-form-error-content-min-length': 'A nóticia deve ter no máximo 5 caractéres',
    'news-detail-form-error-title-max-length': 'Título deve ter no máximo 100 caractéres',
    'news-detail-form-image-hint': 'A imagem será salva no tamanho 720 x 430 px.',
    'news-detail-form-send-push-checkbox': 'Enviar push notification para os usuários',
    'news-detail-form-filter-checkbox': 'Filtrar publico alvo',
    'news-detail-save-success': 'Notícia salva',
    'news-list-create-news-button': 'Nova Notícia',
    'news-list-empty-state-line-1': 'Nenhuma notícia a ser exibida.',
    'news-list-empty-state-line-2': 'Crie sua primeira notícia!',
    'news-list-table-header-published-at': 'Publicada em',
    'news-list-table-header-target': 'Categoria',
    'news-list-table-header-title': 'Título',
    'news-list-table-header-updated-at': 'Atualizado em',
    'news-list-table-target-ALL': 'Geral',
    'news-list-table-target-CAMPAIGN': 'Campanha',
    'news-list-table-target-COMMUNICATE': 'Comunicado',
    'news-list-table-target-CLIENT': 'Geral',
    'news-list-table-target-MEDIC': 'Pesquisa e ciência',
    'news-list-table-target-GENERAL': 'Geral',
    'news-list-table-target-SCIENCE': 'Pesquisa e ciência',
    'news-list-table-target-null': 'Geral',
    'notification-detail-delete-confirm-text': 'Remover notificação?',
    'notification-detail-delete-success': 'Notificação removida',
    'notification-detail-form-error-message-max-length': 'A mensagem deve ter no máxmo 140 caractéres',
    'notification-detail-form-error-title-max-length': 'O título deve ter no máxmo 20 caractéres',
    'notification-detail-form-error-url-max-length': 'A URL deve ter no máxmo 255 caractéres',
    'notification-detail-geo-limited-checkbox': 'Limitar esta notificação a um estado ou a uma cidade específica',
    'notification-detail-has-news-item-checkbox': 'Vincular uma notícia a uma notificação push.',
    'notification-detail-save-success': 'Notificação salva',
    'notification-detail-schedule-checkbox': 'Agendar esta notificação push para uma data futura.',
    'notification-detail-send-now-confirm-text': 'Esta notificação push será enviada imediatamente.',
    'notification-detail-title': 'Nova notificação',
    'notification-detail-title-caption': 'Preencha os dados da notificação conforme os campos abaixo',
    'notification-detail-type': 'Público alvo',
    'notification-detail-filer-public': 'Filtrar publico alvo',
    'notification-list-create-notification-button': 'Criar notificação',
    'notification-list-empty-state-line-1': 'Nehuma notificação push',
    'notification-list-empty-state-line-2': 'Envie sua primeira notificação push',
    'apiaccesslog-list-username': 'Usúario',
    'apiaccesslog-list-type': 'Resultado de conexão',
    'apiaccesslog-list-creat_at': 'Data',
    'apiaccesslog-detail-delete-confirm-text': 'Remover log?',
    'apiaccesslog-detail-delete-success': 'Log removido',
    'apiaccesslog-detail-form-error-message-max-length': 'A mensagem deve ter no máxmo 140 caractéres',
    'apiaccesslog-detail-form-error-title-max-length': 'O título deve ter no máxmo 20 caractéres',
    'apiaccesslog-detail-geo-limited-checkbox': 'Limitar esta log a um estado ou a uma cidade específica',
    'apiaccesslog-detail-save-success': 'Log salva',
    'apiaccesslog-detail-title': 'Detalhes do Log',
    'apiaccesslog-detail-title-caption': 'Dados de tentativas de utilização',
    'apiaccesslog-detail-type': 'Público alvo',
    'apiaccesslog-list-create-apiaccesslog-button': 'Criar log',
    'apiaccesslog-list-empty-state-line-1': 'Nehum log até o momento',
    'apiaccesslog-list-empty-state-line-2': 'Verifique novamente mais tarde',
    'apiaccesslog-detail-username': 'Nome de Usúario',
    'apiaccesslog-detail-type': 'Resultado de conexão',
    'apiaccesslog-detail-date': 'Data',
    'apiaccesslog-detail-header': 'Header de conexão',
    'page-detail-form-error-content-min-length': 'A página deve ter no máximo 5 caractéres',
    'page-detail-save-success': 'Página salva',
    'page-edit-page-title': 'Editar página',
    'procedure-list-active-success': 'Exame atualizado',
    'procedure-list-active-error': 'Não foi possível completar esta ação',
    'procedure-detail-client_info': 'Informações ao cliente',
    'procedure-detail-collection_info': 'Informações de coleta',
    'procedure-detail-collection_material': 'Material',
    'procedure-detail-description': 'Mnemônico',
    'procedure-detail-fasting_hours': 'Jejum',
    'procedure-detail-methodology': 'Metodologia',
    'procedure-detail-name': 'Nome do exame',
    'procedure-detail-reference-value-description': 'Valor',
    'procedure-detail-reference-value-value': 'Nome da amostra',
    'procedure-detail-reference-values-title': 'Valores de referência',
    'procedure-detail-reference-values-title-caption': 'Veja os valores de referência de acordo com as amostras do exame',
    'procedure-detail-result_time': 'Prazo',
    'procedure-detail-title': 'Detalhe do exame',
    'procedure-detail-title-caption': 'Leia abaixo maiores informações sobre o exame',
    'procedure-list-table-header-description': 'Mnemônico',
    'procedure-list-table-header-name': 'Nome',
    'region-detail-delete-confirm-text': 'Remover praça?',
    'region-detail-delete-success': 'Praça removida',
    'region-detail-save-success': 'Praça salva',
    'region-detail-title': 'Detalhe da praça',
    'region-detail-title-caption': 'Preencha os dados da praça conforme os campos abaixo',
    'service-detail-409-error': 'Já existe um serviço com esse nome',
    'service-detail-save-success': 'Serviço salvo',
    'service-list-create-dialog-content': 'Dê um nome para o serviço.',
    'shell-admin': 'Usuários do sistema',
    'shell-admin.create': 'Usuários do sistema',
    'shell-admin.edit': 'Usuários do sistema',
    'shell-admin.list': 'Usuários do sistema',
    'shell-app-version.list': 'Notificação de versão',
    'shell-attendance': 'Pré-Atendimento',
    'shell-attendance.list': 'Pré-Atendimento',
    'shell-attendance.show': 'Pré-Atendimento',
    'shell-attendance-list': 'Lista de pré-atendimentos',
    'shell-email': 'Configuração de e-mails',
    'shell-email.list': 'Configuração de e-mails',
    'shell-email.create': 'Configuração de e-mails',
    'shell-email.edit': 'Configuração de e-mails',
    'shell-campaign': 'Campanhas',
    'shell-campaign.create': 'Campanhas',
    'shell-campaign.edit': 'Campanhas',
    'shell-campaign.list': 'Campanhas',
    'shell-card': 'Cartela de vacinação',
    'shell-card.create': 'Cartela de vacinação',
    'shell-card.edit': 'Cartela de vacinação',
    'shell-card.list': 'Cartela de vacinação',
    'shell-faq-categories': 'Cadastrar Categorias',
    'shell-categories.list': 'Cadastrar Categorias',
    'shell-insurance': 'Convênios',
    'shell-insurance.create': 'Convênios',
    'shell-insurance.edit': 'Convênios',
    'shell-insurance.list': 'Convênios',
    'shell-insurance.ccreate': 'Cidade do convênio',
    'shell-insurance.cedit': 'Cidade do convênio',
    'shell-insurance.screate': 'Estados do convênio',
    'shell-insurance.sedit': 'Estados do convênio',
    'shell-insurance.state': 'Estados/Cidades',
    'shell-insurance-states': 'Estados/Cidades',
    'shell-states': 'Estados',
    'shell-cities': 'Cidades',
    'shell-client': 'Clientes',
    'shell-client.edit': 'Clientes',
    'shell-client.list': 'Clientes',
    'shell-client.report': 'Relatório de Clientes',
    'shell-custom-page': 'Páginas customizadas',
    'shell-custom-home-page': 'Tela inicial do aplicativo',
    'shell-differential': 'Diferenciais',
    'shell-differential.list': 'Diferenciais',
    'shell-faq': 'Perguntas Frequentes',
    'shell-faq.list': 'Adicionar Perguntas',
    'shell-faq.log.list': 'Perguntas Frequentes',
    'shell-faq.log-list': 'Perguntas Frequentes',
    'shell-faq.log.detail': 'Detalhes do Log',
    'shell-general-records': 'Cadastros gerais',
    'shell-group': 'Grupos de acesso',
    'shell-group.create': 'Grupos de acesso',
    'shell-group.edit': 'Grupos de acesso',
    'shell-group.list': 'Grupos de acesso',
    'shell-home': 'Home',
    'shell-me': 'Minha conta',
    'shell-news': 'Notícias',
    'shell-news.create': 'Notícias',
    'shell-news.edit': 'Notícias',
    'shell-news.list': 'Notícias',
    'shell-notification': 'Notificações push',
    'shell-notification.create': 'Notificações push',
    'shell-notification.edit': 'Notificações push',
    'shell-notification.list': 'Notificações push',
    'shell-notification.detail': 'Detalhes da notificação',
    'shell-apiaccesslog': 'Log de acesso a API',
    'shell-apiaccesslog.create': 'Acesso a API',
    'shell-apiaccesslog.edit': 'Acesso a API',
    'shell-apiaccesslog.list': 'Acesso a API',
    'shell-page-about': 'Sobre',
    'shell-page-cid': 'Aviso legal',
    'shell-page-privacy': 'Política de privacidade',
    'shell-page.about': 'Páginas customizadas',
    'shell-page.home-app': 'Tela inicial do aplicativo',
    'shell-page-video-home': 'Banners - Home do aplicativo',
    'shell-page.new-video-home': 'Banners - Home do aplicativo',
    'shell-page.view-video-home': 'Banners - Home do aplicativo',
    'shell-page.video-home': 'Banners - Home do aplicativo',
    'shell-page.cid': 'Páginas customizadas',
    'shell-page.privacy': 'Páginas customizadas',
    'shell-pop-up': 'Pop-ups',
    'shell-pop-up.detail': 'Pop-up',
    'shell-pop-up.create': 'Pop-up',
    'shell-pop-up.list': 'Pop-ups',
    'shell-pre_attendance': 'Pré-Atendimento',
    'shell-procedure': 'Informações de exames',
    'shell-procedure.list': 'Informações de exames',
    'shell-procedure.show': 'Informações de exames',
    'shell-region': 'Praças',
    'shell-region.create': 'Praças',
    'shell-region.edit': 'Praças',
    'shell-region.list': 'Praças',
    'shell-service': 'Serviços',
    'shell-service.list': 'Serviços',
    'shell-target': 'Público alvo',
    'shell-target-category': 'Categorias',
    'shell-target.category': 'Categorias',
    'shell-target.list': 'Público alvo',
    'shell-unit': 'Unidades',
    'shell-unit-list': 'Lista de unidades',
    'shell-unit.create': 'Unidades',
    'shell-unit.edit': 'Unidades',
    'shell-unit.list': 'Unidades',
    'shell-unit.authentication': 'Unidades',
    'shell-users-and-groups': 'Usuários e grupos',
    'shell-time-title': 'Títulos de horários',
    'shell-time-title.list': 'Títulos de horários',
    'shell-vaccine': 'Informações de vacinas',
    'shell-vaccine-vaccine': 'Vacinas',
    'shell-vaccine.create': 'Informações de vacinas',
    'shell-vaccine.edit': 'Informações de vacinas',
    'shell-vaccine.list': 'Informações de vacinas',
    'target-category-detail-409-error': 'Já existe um categoria com este nome neste público alvo',
    'target-detail-409-error': 'Já existe um público alvo com este nome',
    'target-detail-save-success': 'Público alvo salvo',
    'target-list-create-category-dialog-content': 'Dê um nome para a nova categoria',
    'target-list-create-dialog-category-select-hint': 'Opicional',
    'target-list-create-dialog-category-select-label': 'Categoria pai',
    'target-list-create-dialog-content': 'Dê um nome para o novo público alvo.',
    'target-list-create-dialog-name-input-label': 'Nome',
    'target-list-create-dialog-target-select-label': 'Público alvo',
    'target-list-table-header-name': 'Nome',
    'target-list-table-header-parent-group': 'Categoria pai',
    'target-list-table-header-target-group': 'Público alvo',
    'unit-detail-pending-requests': '*Há solicitações pendentes de mudanças de horário!',
    'unit-detail-link-google-unit': 'Vincular uma unidade do Google My Business',
    'unit-is-visible': 'Exibir Unidade',
    'unit-detail-sync-gmb': 'Sincronizar com o Google My Business',
    'unit-detail-add-special-hours': 'Adicionar horários especiais',
    'unit-detail-default-unit-opening-hour-text': 'Horário de funcionamento',
    'unit-detail-delete-confirm-text': 'Remover unidade?',
    'unit-detail-delete-success': 'Unidade removida',
    'unit-detail-form-opening-hour-add-button': 'Adicionar novo horário',
    'unit-detail-form-opening-hour-name': 'Título do horário',
    'unit-detail-form-opening-hour-remove-button': 'Remover',
    'unit-detail-form-opening-hour-value':'Informe aqui os dias e horários específicos',
    'unit-detail-form-unit-address_complement': 'Complemento',
    'unit-detail-form-unit-address_neighborhood': 'Bairro',
    'unit-detail-form-unit-address_number': 'Número',
    'unit-detail-form-unit-address_postal_code': 'CEP',
    'unit-detail-form-unit-address_street': 'Endereço',
    'unit-detail-form-unit-city_id': 'Cidade',
    'unit-detail-form-unit-is-schedule-available': 'Disponível para pré-agendamento',
    'unit-detail-form-unit-latitude': 'Latitude',
    'unit-detail-form-unit-latitude-hint': 'Observe no mapa abaixo a localizaçao da unidade de acordo com as coordenadas',
    'unit-detail-form-unit-longitude': 'Longitude',
    'unit-detail-form-unit-name': 'Nome da unidade',
    'unit-detail-form-unit-observation': 'Observação',
    'unit-detail-form-unit-phone_number': 'Telefone de contato',
    'unit-detail-form-unit-region_id': 'Praça',
    'unit-detail-form-unit-state': 'Estado',
    'unit-detail-remove-opening-hour-confirm-text': 'Remover horário?',
    'unit-detail-remove-opening-hour-deny-text': 'A unidade precisa ter um horário de funcionamento',
    'unit-detail-save-success': 'Unidade salva',
    'unit-detail-section-title-differentials': 'Diferenciais',
    'unit-detail-section-title-differentials-caption': 'Selecione abaixo os Diferenciais disponíveis nesta unidade',
    'unit-detail-section-title-opening-hours': 'Horários',
    'unit-detail-section-title-opening-hours-caption': 'Informe abaixo os horários da unidade',
    'unit-detail-section-title-services': 'Serviços',
    'unit-detail-section-title-services-caption': 'Selecione abaixo os serviços disponíveis nesta unidade',
    'unit-detail-section-title-opening-hours': 'Horário de Funcionamento',
    'unit-detail-section-title-opening-hours-caption': 'Informe abaixo os horários da unidade que irão aparecer no Google',
    'unit-detail-title': 'Detalhe na unidade',
    'unit-detail-title-caption': 'Preencha os dados da unidade conforme os campos abaixo',
    'unit-list-create-unit-button': 'Criar unidade',
    'unit-list-empty-state-line-1': 'Nenhuma unidade',
    'unit-list-empty-state-line-2': 'Crie sua primeira unidade',
    'unit-list-table-header-address-street': 'Endereço',
    'unit-list-table-header-city': 'Cidade',
    'unit-list-table-header-name': 'Unidade',
    'unit-list-table-header-phone-number': 'Telefone',
    'unit-list-table-header-uf': 'UF',
    'vaccine-detail-delete-confirm-text': 'Remover vacina?',
    'vaccine-detail-delete-success': 'Vacina removida',
    'vaccine-detail-form-error-required-target_groups': 'A vacina deve pertencer ao pelo menos uma categoria',
    'vaccine-detail-form-error-title-max-length': 'O nome curto deve ter no máximo 20 caractéres',
    'vaccine-detail-form-vaccine-comment': 'Comentários',
    'vaccine-detail-form-vaccine-name': 'Nome da vacina',
    'vaccine-detail-form-vaccine-recommendations': 'Recomendações',
    'vaccine-detail-form-vaccine-schema': 'Esquema',
    'vaccine-detail-form-vaccine-short_name': 'Nome curto',
    'vaccine-detail-form-vaccine-short_name-hint-text': 'Este nome aparecerá no card de detalhe da vacina',
    'vaccine-detail-save-success': 'Vacina salva',
    'vaccine-detail-section-title-target_groups': 'Categorias',
    'vaccine-detail-section-title-target_groups-caption': 'Selecione as categorias em que essa vacina deve aparecer',
    'vaccine-detail-title': 'Detalhe da vacina',
    'vaccine-detail-title-caption': 'Preencha os dados da vacina conforme os campos abaixo',
    'vaccine-list-create-vaccine-button': 'Criar vacina',
    'vaccine-list-empty-state-line-1': 'Nenhuma vacina',
    'vaccine-list-empty-state-line-2': 'Crie sua primeira vacina',
    'vaccine-list-table-header-name': 'Nome',
    'vaccine-list-table-header-short_name': 'Nome comercial',
    'vaccine-list-table-header-version': 'Nome curto',
    'table-list-new-order': 'Ordenação alterada com sucesso!',
    'version-list-table-header-version': 'Versão',
    'version-list-table-header-forced': 'Atualização forçada',
    'version-list-table-header-os': 'Sistema Operacional',
    'version-list-table-header-configured': 'Configurado em',
    'region-list-empty-state-line-1': 'Nenhuma praça',
    'region-list-empty-state-line-2': 'Crie sua primeira praça',
    'region-list-create-region-button': 'Criar praça',
    'report-success': 'Relatório gerado com sucesso',
    'report-error': 'Não foi possível completar esta ação',
    'open': 'Aberto',
    'closed': 'Fechado',
    'toast-success-hours-sync': 'Horários sincronizados com sucesso!',
    'toast-error-houts-sync': 'Ocorreu algum erro ao sincronizar os horários!',
    'toast-success-approval-attendance-hour': 'Horários aprovados com sucesso!',
    'toast-error-approval-attendance-hour': 'Ocorreu algum erro ao aprovar os horários!',
    'toast-success-approved-special-hours': 'Horários especiais aprovados com sucesso!',
    'toast-error-approved-special-hours': 'Ocorreu algum erro ao aprovar os horários especiais!',
    'toast-success-remove-special-hours': 'Horário especial removido com sucesso!',
    'toast-error-remove-special-hours': 'Ocorreu algum erro ao remover o horário especial!',
    'toast-success-sync-special-hours': 'Horários especiais sincronizados com sucesso!',
    'toast-error-sync-special-hours': 'Ocorreu algum erro ao sincronizar os horários especiais!',
    'toast-success-reject-attendance-hour': 'Horários rejeitados com sucesso!',
    'toast-error-reject-attendance-hour': 'Ocorreu algum erro ao rejeitar os horários!',
    'toast-success-reject-special-hours': 'Horários especiais rejeitados com sucesso!',
    'toast-error-reject-special-hours': 'Ocorreu algum erro ao rejeitar os horários especiais!',
    'toast-success-request-new-special-hours': 'Horários especiais enviados para aprovação do gestor!',
    'toast-error-request-new-special-hours': 'Ocorreu algum erro ao enviar os horários especiais para aprovação!',
    'toast-success-request-change-schedule': 'Horários enviados para aprovação do gestor!',
    'toast-error-request-change-schedule': 'Ocorreu algum erro ao enviar os horários para aprovação!'
}

export default dictionary;



// WEBPACK FOOTER //
// ./client/app/config/locales/pt.js